const filterAnnualInterest = data => {
  // Definindo os níveis de interesse e cores correspondentes
  const interestLevels = ['Altíssimo', 'Alto', 'Médio', 'Baixo']

  const backgroundColors = ['#28a745', '#ffc107', '#fd7e14', '#dc3545']

  // Processando os dados da API
  return {
    labels: interestLevels,
    datasets: [
      {
        label: 'Interesse Anual',
        data: interestLevels.map(level => data.filter(item => item.interest === level).length),
        backgroundColor: backgroundColors,
      },
    ],
  }
}

export default filterAnnualInterest
